import Vue from 'vue';
import VueSlideoutPanel from "vue2-slideout-panel";
import TimeRangePicker from "@/views/domain/charts/TimeRangePicker";

Vue.use(VueSlideoutPanel);

// The VueSlideoutPanel requires the component to be used inside the
// slideout-panel to be globally registered so we are registering this here.
Vue.component('app-time-range-picker', TimeRangePicker);